import { useTranslation } from 'next-i18next';
import { AccordionContentItemWithRadio } from '@/module/public/components/AsideFilter/SubjectAccordion';
import { usePublicMetaFilter } from '@/module/public/hooks/usePublicMetaFilter';
import { RadioGroup } from '@/ui';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/ui_v3/components/accordion';
import { FilterAccordionId } from '../../stores/AccordionStore';
export const QuestionSizeAccordion = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    selectedQuestionSize,
    handleSelectedQuestionSize
  } = usePublicMetaFilter();
  return <AccordionItem value={FilterAccordionId.QuestionSize} data-sentry-element="AccordionItem" data-sentry-component="QuestionSizeAccordion" data-sentry-source-file="QuestionSizeAccordion.tsx">
      <AccordionTrigger data-sentry-element="AccordionTrigger" data-sentry-source-file="QuestionSizeAccordion.tsx">{t('public.questionSize')}</AccordionTrigger>
      <AccordionContent className={'flex flex-col gap-xs'} data-sentry-element="AccordionContent" data-sentry-source-file="QuestionSizeAccordion.tsx">
        <RadioGroup className={'w-full'} value={selectedQuestionSize} onValueChange={handleSelectedQuestionSize} data-sentry-element="RadioGroup" data-sentry-source-file="QuestionSizeAccordion.tsx">
          {[[1, 5], [6, 10], [11, 15], [16, 20]].map(sizes => <AccordionContentItemWithRadio key={sizes.join('-')} name={t('play.header.question', {
          totalCount: sizes.join('-')
        })} value={sizes.join('-')} />)}
        </RadioGroup>
      </AccordionContent>
    </AccordionItem>;
};